import ShadeData from './containers/ShadeData';

export default ShadeData;
